enum PageEnum {
  // 登录
  LOGIN = '/login',
  // 注册
  REGISTERED = '/register',
  //引导页
  GUIDE = '/guide',
  //忘记密码
  FORGOT = '/forgot',
  //选择区号
  CHOOSE_AREA = '/chooseArea',
  // 首页
  HOME = '/home',
  //市场
  MARKET = '/market',
  // 订单
  ORDER = '/order',
  // 币对资金详情
  COIN_FUNDS_DETAIL = '/order/coin/fund_detail',
  ORDER2 = '/order2',
  //大宗订单详情
  BULK_DETAIL = '/order/bulk/detail',
  //申购订单详情
  SUBSCRIPTION_DETAIL = '/order/subscription/detail',
  //  订单详情
  ORDER_DETAIL = '/order/detail/:id',
  // 交易
  TRANSACTION = '/transaction',
  // 合约
  CONTRACT = '/contract',
  //新充值
  MyPageTopUp = '/myPage/topUp',
  // 新充值
  MyPageRiyalTopUp = '/myPage/riyal_topUp',
  //股票
  STOCK = '/stock',
  // 资金
  FUNDS = '/funds',
  //搜索
  SEARCH = '/search',
  //图表
  CHART = '/chart',
  //个人中心
  MINE = '/mine',
  //提现
  WITHDRAW = '/funds/withdraw',
  //提现成功提示
  WITHDRAW_SUCCESS = '/funds/withdraw/success',
  USER_LANGUAGE = '/mine/userLanguage',
  //跟单
  FOLLOW = '/mine/social',
  // 普通贷款
  ORDINARY_LOANS = '/funds/OrdinaryLoan',
  // 普通借贷记录
  ORDINARY_LOANS_RECORD = '/funds/ordinary_loans/log',
  // 申请 额度
  APPLY_AMOUNT_PAGE = '/funds/apply_amount_page',
  //实名认证
  VERIFIED = '/mine/verified',
  //银行卡
  BANK = '/mine/bank',
  //添加收款方式
  ADD_COLLECTION = '/mine/add_payment_method',
  //申购
  SUBSCRIPTION = '/mine/subscription',
  // AI交易
  AITRADE = '/mine/aItrade',
  //资金
  Funds = '/funds',
  //汇率
  EXCHANGE_RATE = '/exchange_rate',
  //选择币种
  CURRENCY = '/funds/currency',
  //充值币种
  RECHARGE_CURRENCY = '/funds/recharge_currency',
  //充值币种确认
  DEPOSIT_CURRENCY_CONFIRMATION = '/funds/recharge_confirmation',
  //充值
  TopUp = '/funds/topUp',
  //充值订单
  TopUp_Order = '/funds/top_up_order',
  //法币
  FiatCurrency = '/funds/fiatCurrency',
  //订单历史 【资金记录】
  ORDER_HISTORY = '/funds/order_history',
  //历史订单详情
  ORDER_HISTORY_DETAIL = '/funds/order_history_detail',
  //订购历史搜索
  ORDER_HISTORY_SEARCH = '/funds/order_history_search',
  //第三方充值
  THIRD_PARTY_RECHARGE = '/funds/third_party_recharge',
  // 划转
  TRANSFER = '/funds/transfer',
  // 闪兑
  SWAP = '/funds/swap',

  //设置中心
  SETTINGS = '/mine/settings',
  // 符号预览
  symbolPreview = '/funds/symbol_preview',
  // FPO 记录
  FPO_RECORD = '/funds/fpo_record',
  // 跟单记录
  TFADING_RECORD = '/copy_Trading_Record/trading_record',
  // 跟单交易记录
  FOLLOW_TRADE_RECORD = '/copy_Trading_Record',
  // 分时图页面
  TIME_CHART = '/time_chart',
  // 跟单记录详情
  FOLLOW_RECORD_DETAIL = '/copy_Trading_Record/detail',
  // 库存股交易记录
  STOCK_HISTORY = '/funds/stock_history',

  // 持仓历史
  POSITION_HISTORY = '/funds/position_history',

  // ETF记录
  ETF_RECORD = '/funds/etf_record',
  // IPO记录
  IPO_RECORD = '/funds/ipo_record',
  // 交易记录
  TRADING_RECORD = '/funds/trading_record',

  //客服
  SERVICE = '/mine/service',

  //涨跌色
  UPDOWNCOLOR = '/mine/upDownColorConfig',

  //帮助中心
  HELPCENTER = '/mine/help_center',

  //帮助中心 文章
  HELPARTICLE = '/mine/helpArticle',

  //帮助中心文章详情
  HELPARTICLEDETAIL = '/mine/helpArticle_detail',

  //帮助中心 反馈
  HELPFEEDBACK = '/mine/helpFeedback',

  //公司简介
  COMPANY_PROFILE = '/mine/company_profile',

  //关于我们
  ABOUT = '/mine/about',

  //主题
  THEME = '/mine/theme',

  // ieo
  IEOLISTVIEW = '/funds/exchangeOffListView',
  // 商家充值
  BUSINESSRECHARGE = '/funds/businessRecharge',
  //理财列表
  FINANCELISTVIEW = '/funds/financeListView',

  //购买申购
  BUYAI = '/funds/buyai',

  //购买申购
  BUYSUBSCRIBE = '/funds/buySubscribe',

  /**
   * 购买申购订单详情页buySubscribeOrderDetail
   */
  BUYSUBSCRIBEORDER = '/funds/buySubscribeOrderDetail',

  /**
   * # 新闻详情
   */
  NEWSDETAIL = '/message/newsDetail',

  /**
   * # 公告详情
   */
  ANNOUNCEMENTDETAIL = '/message/announcementDetail',

  /**
   * # 修改密码
   */
  CHANGEPASSWORD = '/mine/changePassword',

  //修改用户信息
  CHANGEUSERINFORMATION = '/mine/changeUserInformation',

  //修改用户信息
  CHANGEUSERINFO = '/mine/changeUserInfo',
  //更改支付密码
  CHANGEPAYMENTPASSWORD = '/mine/changePayPassword',

  //订单详情
  CONTRACT_ORDER_DETAIL = '/order/detail',

  // 论坛详情
  FORUMDETAIL = '/home/forumDetail',

  // 消息通知
  MESSAGE = '/message',

  // 公告
  ANNOUNCEMENT = '/announcement',

  // 新闻
  NEWS = '/news',
  //订单消息
  ORDERMESSAGE = '/message/order',

  // 大宗交易
  BLOCKTRADE = '/blockTrade',

  //订单详情(充值提现)
  ORDERHISTORYDETAIL = '/funds/orderHistoryDetail/:id',

  //订单详情（买入、卖出）
  TRADINGHISTORYDETAIL = '/funds/tradingHistoryDetail',

  //引导页
  BOOTPAGE = '/bootPage',

  //vip
  VIP = '/mine/vip',

  //在线客服
  ONLINESUPPORT = '/mine/onlinesupport',
  //邀请
  INVITE = '/invite',
  //返佣排名
  REBATE_RANKING = '/rebateRanking',
  //邀请设置
  INVITATION_SETTINGS = '/invitation_settings',
  //vip升级
  UPGRADEPLAN = '/mine/upgradeplan',
  //AI订单
  AI_ORDER = '/mine/ai_order',
  //AI子订单
  AI_SUB_ORDER = '/mine/ai_child_Order',
  //AI订单详情
  AI_ORDER_DETAIL = '/mine/ai_order_detail',
  // 功能列表
  FUNCTION_LIST = '/mine/function_list',
  // 基金
  FUND = '/funds/fund',
  // 基金 Detail
  FUNDDETAIL = '/funds/fundDetail',
  LOANS = '/funds/LOANS',
  Fund = '/funds/fund',

  //PChome
  PCHOME = '/pc_home',
  // VIP
  APPLY_VIP = '/vip',
  // 银行卡充值
  BANK_RECHARGE = '/funds/bank_recharge',
  // 银行卡充值订单
  BANK_RECHARGE_ORDER = '/funds/bank_recharge_order',
  // 订单消息详情
  ORDER_MESSAGE_DETAIL = '/message/order_detail',
  // 借贷记录
  LOANS_RECORD = '/funds/loans/log',
  // 日内交易
  DAY_TRADING = '/day_trading',
  // 日内交易记录
  DAY_TRADING_RECORD = '/day_trading/record',
  // 跟单配置
  ORDER_CONFIGURATION = '/order_configuration',
  // 引导页
  GUIDE_PAGE = '/guide_page',
  // 客服列表
  SERVICE_LIST = '/service_list',
  // VIP申请版本
  VIP_APPLICATION_VERSION = '/vip_application_version',
  // 隔日交易
  OVERNIGHT_TRADING = '/overnight_trading',
  // 大宗
  BLOCK = '/block',
  // IPO
  IPO = '/ipo',
  //ETF
  ETF = '/etf',
}

export default PageEnum;
